import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MotifButtonModule } from '@ey-xd/ng-motif';

@Component({
  selector: 'app-user-unauthorize',
  standalone: true,
  imports: [RouterLink, MotifButtonModule],
  templateUrl: './user-unauthorize.component.html',
  styleUrl: './user-unauthorize.component.scss',
})
export class UserUnauthorizeComponent {}
